import {Switch} from "antd";

const SwitchCustom = props => {

    return (
        <div style={{textAlign: "right"}}>
            <Switch {...props}/>
        </div>
    )
}

export default SwitchCustom